export interface OffsetConfig {
  x?: number;
  y?: number;
}

export function parseOffsetConfig(value: string) {
  const config: OffsetConfig = {};

  if (/^-?\d*\.?\d+$/.test(value?.trim() ?? "")) {
    config.y = parseFloat(value?.trim() ?? "");
    return config;
  }

  if (!value) return config;

  const parts = value.split(",").map((part) => part.trim());

  parts.forEach((part) => {
    const [key, val] = part.split(":").map((s) => s.trim());
    const numValue = parseFloat(val);

    switch (key.toLowerCase()) {
      case "x":
        config.x = numValue;
        break;
      case "y":
        config.y = numValue;
        break;
    }
  });

  return config;
}
